var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-basket',{attrs:{"tag":"span"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var totalItems = ref.totalItems;
return [_c('span',{class:{
                'basket-count': true,
                'basket-count--big': totalItems > 9,
                'basket-count--very-big': totalItems > 99,
            }},[_vm._v(_vm._s(totalItems))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }